import { createFileRoute } from "@tanstack/react-router";

import {
  Layout,
  LayoutAside,
  LayoutBody,
  LayoutContent,
  LayoutHeader,
} from "@/client/components/layout";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/client/components/shad/breadcrumb";
import { useSkopaAllIntercept } from "@/client/hooks/useSkopaQuery";
import { Spinner } from "@/client/components/shad/spinner";
import {
  Item,
  ItemActions,
  ItemContent,
  ItemDescription,
  ItemHeader,
  ItemTitle,
} from "@/client/components/shad/item";
import { Badge } from "@/client/components/shad/badge";
import { Button } from "@/client/components/shad/button";
import { IconX } from "@tabler/icons-react";
import {
  Card,
  CardAction,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/client/components/shad/card";

export const Route = createFileRoute("/(protected)/settings/skopa/logs")({
  component: RouteComponent,
});

function RouteComponent() {
  const { data, isPending } = useSkopaAllIntercept();

  if (!data) return <Spinner />;

  return (
    <Layout>
      <LayoutHeader>
        <Breadcrumb>
          <BreadcrumbList className="font-bold text-base">
            <BreadcrumbItem>
              <BreadcrumbPage>Skopa</BreadcrumbPage>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>Config</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </LayoutHeader>
      <LayoutContent>
        <LayoutBody>
          <div className="grid gap-3 mt-4">
            {data.map((item) => {
              return (
                <Item variant="outline">
                  <ItemContent>
                    <ItemTitle>
                      <Badge variant="secondary">ID: {item.id}</Badge>
                      Track ID: {item.track_id}
                    </ItemTitle>
                    <ItemDescription>
                      {new Intl.DateTimeFormat("en-GB", {
                        dateStyle: "full",
                        timeStyle: "short",
                      }).format(new Date(item.created_at))}
                    </ItemDescription>
                  </ItemContent>
                  <ItemActions>
                    <Button variant="outline" size="xs">
                      <IconX />
                      Remove
                    </Button>
                  </ItemActions>
                </Item>
              );
            })}
          </div>
        </LayoutBody>
        <LayoutAside>
          <div className="h-full animate-in fade-in duration-500">
            <Card>
              <CardHeader>
                <CardTitle>Skopa event logs</CardTitle>
                <CardDescription>
                  Search for skopa event and download logs
                </CardDescription>
              </CardHeader>
            </Card>
          </div>
        </LayoutAside>
      </LayoutContent>
    </Layout>
  );
}
